import { API_ROUTE_TRADE_IN_ORDERS } from '@/resources/api-routes'
import { put } from '@/util/auth'

import type { Status } from './getTradeInOrders'

const IS_NEW_BACKEND_API = true

type UpdateOrderType = {
  orderId: string
  newStatusCode: Status
  comment: string
}

export type UpdateOrdersType = {
  orders: Array<UpdateOrderType>
}

export const updateTradeInOrders = async ({ payload }: { payload: UpdateOrdersType }) =>
  put(API_ROUTE_TRADE_IN_ORDERS, payload, IS_NEW_BACKEND_API)
